import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";
import DataTable from "../../../assets/components/dataTable";

import NotificationActions from "../../../store/actions/notification";
import { Button } from "semantic-ui-react";
import User from "../../../models/User";

class MashieAdminsIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            users: [],
            error: false,
        };

        if (this.props.user.has("MASHIE_ADMIN") === false) {
            this.props.history.push("/members");
        }
    }

    componentDidMount() {
        this.getAdmins();
    }

    notification(type, text) {
        this.props.dispatch(NotificationActions.create({ type, text }));
    }

    getAdmins() {
        this.setState({ loading: true });
        User.getMashieAdmins()
            .then((users) => {
                this.setState({
                    loading: false,
                    users: users.data.data.map((u) => new User(u)),
                });
            })
            .catch((error) => {
                this.setState({ loading: false, error: true });
                this.notification(
                    "error",
                    "Failed to load users, please try again"
                );
            });
    }

    table() {
        const headers = [
            { key: "profileImage", text: "Profile image" },
            { key: "name", text: "name" },
            { key: "actions", text: "Actions" },
        ];

        const data = this.state.users.map((user) => {
            return {
                profileImage: {
                    value: (
                        <img
                            src={user.profileImageUrl}
                            className="profile-logo-sm"
                        />
                    ),
                },
                name: { value: user.name, search: user.name },
                actions: {
                    value: (
                        <Link to={`/mashie-admins/${user._id}`}>
                            <Button primary className="theme">
                                Edit
                            </Button>
                        </Link>
                    ),
                },
            };
        });

        return (
            <DataTable
                loading={this.state.loading}
                headers={headers}
                data={data}
            />
        );
    }

    body() {
        return (
            <div className="container-fluid" style={{ overflowX: "scroll" }}>
                <div className="row page-header mt-3">
                    <div className="col-sm-12 col-md-8">
                        <h2>Mashie admins</h2>
                    </div>
                    <div className="col-sm-12 col-md-4 text-right">
                        <Link to="/mashie-admins/create">
                            <Button primary className="theme">
                                Add admin
                            </Button>
                        </Link>
                    </div>
                </div>
                <div className="row">
                    <div className="col">{this.table()}</div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className="d-flex main">
                    <Header history={this.props.history} />

                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        notification: state.notification,
    };
}

export default connect(mapStateToProps)(MashieAdminsIndex);
